export default {
  computed: {
    $permissions() {
      return this.permissions;
    }
  }
};
